import { useEffect, useState } from 'react';
import { useAppStore } from '@/stores/appStore';
import { WifiOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { setIsOffline } = useAppStore();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setIsOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setIsOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setIsOffline]);

  if (isOnline) return null;

  return (
    <div className={cn(
      'fixed bottom-20 lg:bottom-4 left-1/2 -translate-x-1/2 z-50',
      'bg-yellow-500 text-yellow-950 px-4 py-2 rounded-full shadow-lg',
      'flex items-center gap-2 text-sm font-medium'
    )}>
      <WifiOff className="w-4 h-4" />
      <span>You are offline</span>
    </div>
  );
}
